import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo Curso',
  path: '/pessoal/pestipocurso',
  name: 'pestipocurso',
  component: () => import('@/views/pessoal/pestipocurso/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODECURSONOVO_MENU_1400800599],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo Curso',
  path: '/pessoal/pestipocurso/cadastro/:id?',
  parent: 'pestipocurso',
  name: 'pestipocurso_create',
  component: () => import('@/views/pessoal/pestipocurso/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODECURSONOVO_MENU_1400800599],
  },
  goesToMenu: true,
 },
]
